<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="sectionForm">
		<div class="grid mt-0">
			<div class="col-12 py-0">
				<div class="flex align-items-center justify-content-center font-semibold text-lg">
					{{ 'KEY_SECTION' | translate }}
				</div>
			</div>
			<div class="col-12">
				<!-- <div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.KeyHelp, 'label')">{{
					'KEY_SECTION' | translate }}</div> -->
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.KeyHelp, 'borderInput')">
					<input type="text" pInputText class="w-full" formControlName="KeyHelp" autocomplete="KeyHelp"
						placeholder="{{ 'KEY_SECTION' | translate }}" maxlength="50" />
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.KeyHelp)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
		</div>
		<!-- LANGUAGES TITLE CONTENT -->
		<div class="grid mt-0">
			<div class="col-12">
				<div class="flex align-items-center justify-content-center font-semibold text-lg">
					{{ 'SECTION' | translate }}
				</div>
			</div>
		</div>
		<div class="grid">
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.TitleIt, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('it-IT')" width="20">
						{{ 'ITALIANO' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.TitleIt, 'borderInput')">
					<input type="text" pInputText class="w-full" formControlName="TitleIt" autocomplete="TitleIt"
						placeholder="{{ 'ITALIANO' | translate }}" maxlength="100" />
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.TitleIt)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.TitleEn, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('en-US')" width="20">
						{{ 'INGLESE' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.TitleEn, 'borderInput')">
					<input type="text" pInputText class="w-full" formControlName="TitleEn" autocomplete="TitleEn"
						placeholder="{{ 'INGLESE' | translate }}" maxlength="100" />
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.TitleEn)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.TitleEs, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('es-ES')" width="20">
						{{ 'SPAGNOLO' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.TitleEs, 'borderInput')">
					<input type="text" pInputText class="w-full" formControlName="TitleEs" autocomplete="TitleEs"
						placeholder="{{ 'SPAGNOLO' | translate }}" maxlength="100" />
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.TitleEs)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.TitleDe, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('de-DE')" width="20">
						{{ 'TEDESCO' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.TitleDe, 'borderInput')">
					<input type="text" pInputText class="w-full" formControlName="TitleDe" autocomplete="TitleDe"
						placeholder="{{ 'TEDESCO' | translate }}" maxlength="100" />
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.TitleDe)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.TitleFr, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('fr-FR')" width="20">
						{{ 'FRANCESE' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.TitleFr, 'borderInput')">
					<input type="text" pInputText class="w-full" formControlName="TitleFr" autocomplete="TitleFr"
						placeholder="{{ 'FRANCESE' | translate }}" maxlength="100" />
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.TitleFr)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.TitleNl, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('nl-NL')" width="20">
						{{ 'OLANDESE' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.TitleNl, 'borderInput')">
					<input type="text" pInputText class="w-full" formControlName="TitleNl" autocomplete="TitleNl"
						placeholder="{{ 'OLANDESE' | translate }}" maxlength="100" />
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.TitleNl)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.TitlePl, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('pl-PL')" width="20">
						{{ 'POLACCO' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.TitlePl, 'borderInput')">
					<input type="text" pInputText class="w-full" formControlName="TitlePl" autocomplete="TitlePl"
						placeholder="{{ 'POLACCO' | translate }}" maxlength="100" />
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.TitlePl)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.TitleRu, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('ru-RU')" width="20">
						{{ 'RUSSO' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.TitleRu, 'borderInput')">
					<input type="text" pInputText class="w-full" formControlName="TitleRu" autocomplete="TitleRu"
						placeholder="{{ 'RUSSO' | translate }}" maxlength="100" />
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.TitleRu)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1"
					[ngClass]="newShowErrors(this.f.TitleSk, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('sk-SK')" width="20">
						{{ 'SLOVENO' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center"
					[ngClass]="newShowErrors(this.f.TitleSk, 'borderInput')">
					<input type="text" pInputText class="w-full" formControlName="TitleSk" autocomplete="TitleSk"
						placeholder="{{ 'SLOVENO' | translate }}" maxlength="100" />
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.TitleSk)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1" [ngClass]="newShowErrors(this.f.TitleHu, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('hu-HU')" width="20">
						{{ 'UNGHERESE' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.TitleHu, 'borderInput')">
					<input type="text" pInputText class="w-full" formControlName="TitleHu" autocomplete="TitleHu"
						placeholder="{{ 'UNGHERESE' | translate }}" maxlength="100" />
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.TitleHu)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1" [ngClass]="newShowErrors(this.f.TitlePt, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('pt-PT')" width="20">
						{{ 'PORTOGHESE' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.TitlePt, 'borderInput')">
					<input type="text" pInputText class="w-full" formControlName="TitlePt" autocomplete="TitlePt"
						placeholder="{{ 'PORTOGHESE' | translate }}" maxlength="100" />
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.TitlePt)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1" [ngClass]="newShowErrors(this.f.TitleSv, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('sv-SE')" width="20">
						{{ 'SVEDESE' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.TitleSv, 'borderInput')">
					<input type="text" pInputText class="w-full" formControlName="TitleSv" autocomplete="TitleSv"
						placeholder="{{ 'SVEDESE' | translate }}" maxlength="100" />
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.TitleSv)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12 pb-0">
				<div class="flex align-items-center justify-content-start pb-1" [ngClass]="newShowErrors(this.f.TitleCs, 'label')">
					<div class="flex align-items-center gap-2">
						<img [src]="getFlagImage('cs-CZ')" width="20">
						{{ 'CECO' | translate }}
					</div>
				</div>
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.TitleCs, 'borderInput')">
					<input type="text" pInputText class="w-full" formControlName="TitleCs" autocomplete="TitleCs"
						placeholder="{{ 'CECO' | translate }}" maxlength="100" />
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.TitleCs)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>